import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getCustomerPackage, getPictureByKey } from '@/views/custom-layout/api';
export default {
  name: 'package_list_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: Object,
    packageListData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isPackageListDecoration: Boolean,
    programmeUniqueId: {
      type: String,
      default: ''
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        margin_top: [{
          required: true,
          type: 'number',
          message: '间距必须为数字值',
          trigger: 'change'
        }],
        z_index: [{
          required: true,
          pattern: /^(?:[1-9]|[1-9][0-9])$/,
          message: '请输入1-99之间的整数！',
          trigger: 'change'
        }],
        head_image: [{
          required: true,
          message: '顶部方案图不可为空',
          trigger: 'change'
        }],
        background_colour: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }]
      },
      packageData: {
        package_unique_id: '',
        // 礼包unique_id
        package_image: '',
        //礼包图片
        package_name: '' //礼包名称
      },
      customerProjectList: [],
      //方案列表
      customerPackageList: [],
      //礼包列表

      showPictureLibrary: false,
      pictureInfo: {},
      pictureList: [],
      depot: {},
      updateIndex: 0,
      pictureIndex: 1
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key,
        key_type: this.value.config.show_type
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureInfo = picture;
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      if (this.pictureIndex === 1) {
        // 更改顶部方案图
        this.value.config.head_image = path;
      } else {
        // 更改礼包商品图
        this.value.config.value[this.updateIndex]['package_image'] = path;
      }
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(type, index) {
      // type: 1 顶部方案图 2 礼包商品图
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.pictureList = this.pictureInfo[type];
      this.pictureIndex = type;
      this.showPictureLibrary = true;
    },
    changePackage: function changePackage(value, index) {
      var data = this.customerPackageList.find(function (i) {
        return i.unique_id === value;
      });
      if (data === undefined) {
        return;
      }
      var package_name = data.name,
        price_show = data.price_show,
        platform_rate_show = data.platform_rate_show,
        platform_price_show = data.platform_price_show,
        jd_comment_count_show = data.jd_comment_count_show,
        package_image = data.impression_drawing;
      this.$set(this.value.config.value, index, _objectSpread(_objectSpread({}, this.value.config.value[index]), {}, {
        package_name: package_name,
        // 礼包名称
        price_show: price_show,
        // 售价
        platform_rate_show: platform_rate_show,
        //平台折扣
        platform_price_show: platform_price_show,
        // 划线价
        jd_comment_count_show: jd_comment_count_show,
        // 评论数
        package_image: package_image //礼包商品图
      }));
    },
    addPackage: function addPackage() {
      this.value.config.value.push(_objectSpread({}, this.packageData));
    },
    handleDelUpload: function handleDelUpload(index) {
      var _this2 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.value.splice(index, 1);
      }).catch(function () {});
    },
    changeProject: function changeProject(value, type) {
      if (this.isPackageListDecoration) {
        return;
      }
      if (value) {
        var data = this.customerProjectList.find(function (i) {
          return i.unique_id === value;
        });
        if (data === undefined) {
          return;
        }
        this.customerPackageList = data.children;
        if (type === 'init') {
          // 组件预置初始数据时， 不需要清空选择项
          return;
        }
        this.value.config.value = this.value.config.value.map(function (i) {
          return _objectSpread(_objectSpread({}, i), {}, {
            package_unique_id: '',
            // 礼包unique_id
            package_name: '' //礼包名称
          });
        });
      }
    },
    onUpload: function onUpload(index) {
      if (typeof index === 'number') {
        this.$refs.uploadBanner[index].uploadBanner();
      } else {
        this.$refs["uploadBanner".concat(index)].uploadBanner();
      }
    },
    emitUploadFile: function emitUploadFile(res, item, prop) {
      item[prop] = "".concat(this.$ossurl).concat(res);
    },
    onDelete: function onDelete(item, prop) {
      if (!item[prop]) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        item[prop] = '';
      });
    },
    getPackageList: function getPackageList() {
      var _this3 = this;
      return new Promise(function (resolve) {
        if (_this3.isPackageListDecoration) {
          _this3.customerPackageList = _this3.packageListData;
          resolve();
          return;
        }
        var _this3$info = _this3.info,
          customer_id = _this3$info.customer_id,
          module = _this3$info.module;
        // 获取礼包方案下拉数据
        getCustomerPackage({
          customer_id: customer_id,
          only_group: 0
        }, module).then(function (res) {
          _this3.customerProjectList = res.data;
        }).finally(function () {
          resolve();
        });
      });
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this4.$set(_this4.value, 'config', _objectSpread(_objectSpread({
              margin_top: 15,
              z_index: 2,
              head_image: '',
              //顶部方案图
              programme_unique_id: '',
              //方案unique_id
              background_colour: '#ffeed2',
              //背景色
              show_type: _this4.value.show_type,
              //组件展示样式 1-单列 2-双列
              value: [_objectSpread({}, _this4.packageData), _objectSpread({}, _this4.packageData)]
            }, _this4.value.config), _this4.isPackageListDecoration ? {
              programme_unique_id: _this4.programmeUniqueId
            } : {}));
            _this4.getPicture();
            _context.n = 1;
            return _this4.getPackageList();
          case 1:
            _this4.changeProject(_this4.value.config.programme_unique_id, 'init');
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }
};